import React from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import { selectors as frontendConfigurationSelectors } from '@rover/react-lib/src/redux/ducks/frontendConfiguration.duck';
import { selectors as petsSelectors } from '@rover/react-lib/src/redux/ducks/pets.duck';
import { selectors as searchSelectors } from '@rover/react-lib/src/redux/ducks/search.duck';
import { selectors as serviceTypeSelectors } from '@rover/react-lib/src/redux/ducks/serviceTypes.duck';

import { selectors as searchFiltersSelectors } from '../../SearchFilters.duck';
import { effects as searchPageEffects } from '../../SearchPage.duck';

import SimplifiedFiltersBar from './SimplifiedFiltersBar';

const selector = (state) => ({
  searchFilters: searchFiltersSelectors.getFilters(state),
  serviceType: (() => {
    const filters = searchFiltersSelectors.getFilters(state);
    const options = searchFiltersSelectors.getPetTypeBrowsableServiceTypeOptions(state);
    const serviceType = options.find((option) => option.value === filters.serviceType);
    return serviceType || null;
  })(),
  serviceTypeOptions: searchFiltersSelectors.getPetTypeBrowsableServiceTypeOptions(state),
  locale: frontendConfigurationSelectors.getLanguage(state),
  allPets: petsSelectors.getPets(state),
  petSizeBuckets: searchSelectors.getSearchDogSizeBuckets(state),
  weightUnit: searchSelectors.getSearchWeightUnit(state),
  allServiceTypeFilterOptions: searchSelectors.getSearchFiltersOptions(state),
  getServiceTypeBySlug: serviceTypeSelectors.getServiceTypeBySlug(state),
});

const effects = {
  onServiceTypeChange: searchPageEffects.updateFiltersAndFireSearchOnChange,
  updateFiltersAndFireSearchOnChange: searchPageEffects.updateFiltersAndFireSearchOnChange,
};

const SimplifiedFiltersBarContainer = (): JSX.Element => {
  return (
    <Connect selector={selector} effects={effects}>
      {(connectedProps) => <SimplifiedFiltersBar {...connectedProps} />}
    </Connect>
  );
};

export default SimplifiedFiltersBarContainer;
